<template>
  <div class="locale-switcher">
    <!-- {{ initLocale() }} -->
    <b-nav-item-dropdown :dropup="dropup" :text="dropdownLbl" right>
      <b-dropdown-item class="locale-link" v-for="locale in locales" :key="locale.id" @click="setLocale(locale)" :class="{ 'is-current': locale === activeLocale }" href="#">
        {{ getLanguageString(locale) }}
      </b-dropdown-item>
    </b-nav-item-dropdown>
  </div>
</template>
<script>
import Vue from 'vue'

const localeStrings = {
  en_us: "English",
  zh_cn: "简体中文",
  zh_hk: "正體中文"
}


export default {
  name: 'localeSwitcher',
  props: {
    locales: {
      type: Array,
      default: ['zh_hk']
    },
    showFull: Boolean,
    dropup: Boolean,
    locLabel: {
      type: String,
      default: ''
    }
  },
  data: function() {
    return {
      activeLocale: Vue.config.lang
    }
  },
  computed: {
    dropdownLbl: function() {
      if (this.locLabel){
        return this.showFull ? localeStrings[locLabel] : locLabel
      } else {
      return this.showFull ? localeStrings[this.activeLocale] : this.activeLocale}
    }
  },
  methods: {
    //set locale of the instance and insert to cookies
    setLocale: function(locale) {
      Vue.config.lang = locale
      this.activeLocale = locale
      this.$cookie.set('locale', locale)
      this.$i18n.locale = Vue.config.lang
      console.log("New locale = " + Vue.config.lang + ": language = " + localeStrings[Vue.config.lang])
    },
    //get Language name to show on nav
    getLanguageString: function(locale) {
      return this.showFull ? localeStrings[locale] : locale
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/LocaleSwitcher.vue